import React, {useEffect, useState} from 'react';
import { Fade } from 'react-slideshow-image';

import GalleryCont from './GalleryCont';
import LittleQuote from './LittleQuote';
import Map from '../Reusable/Map';
import { assetUrl } from '../../utils/graphqlClient';
import { useAppContext } from '../../context/AppContext';

import './home.scss';

import quotes from '../../data/quotes';

const Home = () => {
  const { state } = useAppContext();
  const { labels, pictures, perPage, allGpsDatas } = state;
  const [quoteToShow, setQuoteToShow] = useState({});
  const [randomNumber, setRandomNumber] = useState();

  const fadeProperties = {
    arrows: false,
    duration: 5000,
    transitionDuration: 1000,
    infinite: true,
    indicators: true,
  };

  const publicPictures = pictures.filter((picture) => picture.isPublished !== false);

  // Permet de filtrer les photos du slider
  // Ne sont présente dans le slider que les photos avec l'attribut isStarred passé à true
  const sliderPictures = publicPictures.filter((picture) => picture.isStarred === true);

  // Permet de sélectionner la quote à afficher dans le slider
  useEffect(() => {
    const randomNumb = Math.floor(Math.random() * (quotes.length - 1) + 1);
    setRandomNumber(randomNumb);
  }, [])

  useEffect(() => {
    if (quotes !== undefined && randomNumber !== undefined) {
      const findQuote = quotes.find((quote) => quote.id === randomNumber);
      setQuoteToShow(findQuote);
    }
  }, [randomNumber]);
  
  return (
    <>
      <div className="home">

        <div className="slide-container">
          <Fade {...fadeProperties}>
            {sliderPictures.map((picture) => (
              <div key={picture.name} className="each-fade">
                <div className="image-container">
                  <div className="background-options" style={{'backgroundImage': `linear-gradient( rgba(0, 0, 0, .5), rgba(0, 0, 0, .2) ), url(${assetUrl(`uploads/${picture.src}`)})`}} />
                  {quoteToShow !== undefined &&
                    <LittleQuote quote={quoteToShow}/>
                  }
                  <div className="short-desc">
                    <h2>{picture.name}</h2>
                    <p>{picture.place}</p>
                  </div>
                </div>
              </div>
            ))}
          </Fade>
        </div>

        <div className="block-gallery">
          <div className="title">
            <h2>The Photo Gallery</h2>
            <p>Take a look at my work</p>
          </div>
          <GalleryCont pictures={publicPictures} labels={labels} perPage={perPage} />
        </div>
        <div className="block-map">
          <div className="title">
            <h2>Gallery World's Map</h2>
            <p>Where my photos are taken</p>
          </div>
          <Map size={50} zoom={3} usage={"more"} allGpsDatas={allGpsDatas} />
        </div>
      </div>
    </>
  );  
};

export default Home;
